<template>
  <div>
    <el-row type="flex" justify="center" align="middle" :gutter="5">
      <el-col :span="11"
        ><div v-if="title1" class="grid-title">{{ title1 }}</div></el-col
      >
      <el-col :span="2" />
      <el-col :span="11"
        ><div v-if="title2" class="grid-title">{{ title2 }}</div></el-col
      >
    </el-row>
    <el-row type="flex" justify="center" align="middle" :gutter="5">
      <el-col :span="11">
        <div style="height: 350px">
          <GridVx
            ref="agGrid1"
            dom-layout="scrool"
            :disabled-sortable="null"
            :columns="columns1"
            :rows="rowData1"
            :auto-select-first-row="false"
            class="agGrid"
            :auto-size-cell="true"
            :is-row-selectable="isRowSelectable1"
          />
          <GridPagingMini
            target="agGrid1"
            :total-size="pageParams1.totalPage"
            :page-num="pageParams1.pageNum"
            @pageChanged="onPageChanged1"
            @onPageSizeChange="onPageSizeChange1"
          />
        </div>
      </el-col>
      <el-col :span="2">
        <el-row type="flex" justify="center">
          <button
            class="btn only-icon"
            style="margin-bottom: 10px"
            @click="transDataToSecondTable"
          >
            <i class="el-icon-d-arrow-right"></i>
          </button>
        </el-row>
        <el-row type="flex" justify="center">
          <button
            class="btn only-icon"
            style="margin-bottom: 10px"
            @click="transDataToFirstTable"
          >
            <i class="el-icon-d-arrow-left"></i>
          </button>
        </el-row>
      </el-col>
      <el-col :span="11">
        <div style="height: 350px">
          <GridVx
            ref="agGrid2"
            dom-layout="scrool"
            :disabled-sortable="null"
            :columns="columns2"
            :rows="rowData2"
            :auto-select-first-row="false"
            class="agGrid"
            :auto-size-cell="true"
          />
          <GridPagingMini
            target="agGrid2"
            :total-size="pageParams2.totalPage"
            :page-num="pageParams2.pageNum"
            @pageChanged="onPageChanged2"
            @onPageSizeChange="onPageSizeChange2"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import GridPagingMini from '@/components/grid/GridPagingMini.vue'
export default {
  components: { GridPagingMini },
  props: {
    isRowSelectable1: {
      type: Function
    },
    title1: String,
    title2: String,
    columns1: {
      type: Array,
      default: () => []
    },
    rows1: {
      type: Array,
      default: () => []
    },
    page1: {
      type: Object
    },
    columns2: {
      type: Array,
      default: () => []
    },
    rows2: {
      type: Array,
      default: () => []
    },
    page2: {
      type: Object
    }
  },
  data() {
    return {
      rowData1: null,
      rowData2: null,

      pageParams1: {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      },
      pageSizeOptions1: [10, 20, 30, 50],
      totalRecords1: null,

      pageParams2: {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      },
      pageSizeOptions2: [10, 20, 30, 50],
      totalRecords2: null
    }
  },
  watch: {
    rows1: {
      immediate: true,
      handler(val) {
        this.rowData1 = val
      }
    },
    rows2: {
      immediate: true,
      handler(val) {
        this.rowData2 = val
      }
    },
    page1: {
      immediate: true,
      handler(val) {
        this.pageParams1 = { ...this.pageParams1, ...val }
        // if (
        //   this.pageParams1.pageNum !== val.pageNum ||
        //   this.pageParams1.pageSize !== val.pageSize ||
        //   this.pageParams1.totalPage !== val.totalPage
        // ) {
        // }
      }
    },
    page2: {
      immediate: true,
      handler(val) {
        this.pageParams2 = { ...this.pageParams2, ...val }
      }
    }
  },
  mounted() {
    this.gridApi1 = this.$refs.agGrid1.gridApi
    this.gridColumnApi1 = this.$refs.agGrid1.columnApi
    this.gridApi2 = this.$refs.agGrid2.gridApi
    this.gridColumnApi2 = this.$refs.agGrid2.columnApi
  },
  methods: {
    // handle pagination
    onPageChanged1(pageNum) {
      this.pageParams1.pageNum = pageNum
      this.$emit('pageChanged1', this.pageParams1)
    },
    onPageSizeChange1(pageSize) {
      this.pageParams1.pageSize = pageSize
      this.pageParams1.pageNum = 1
      this.$emit('pageChanged1', this.pageParams1)
    },

    onPageChanged2(pageNum) {
      this.pageParams2.pageNum = pageNum
      this.$emit('pageChanged2', this.pageParams2)
    },
    onPageSizeChange2(pageSize) {
      this.pageParams2.pageSize = pageSize
      this.pageParams2.pageNum = 1
      this.$emit('pageChanged2', this.pageParams2)
    },

    transDataToSecondTable() {
      const rowsSelected = this.gridApi1.getSelectedRows()
      // this.rows1 = this.rows1.filter((row) => !rowsSelected.includes(row))
      this.gridApi1.applyTransaction({
        remove: rowsSelected
      })
      this.gridApi2.applyTransaction({
        add: rowsSelected
      })

      // this.rows2.push(...rowsSelected)

      const rows1 = this.rows1?.filter(row => !rowsSelected.includes(row))
      const rows2 = [...this.rows2, ...rowsSelected]

      this.$emit('transferData', rows1, rows2)
    },
    transDataToFirstTable() {
      const rowsSelected = this.gridApi2.getSelectedRows()
      // this.rows2 = this.rows2.filter((row) => !rowsSelected.includes(row))
      this.gridApi2.applyTransaction({
        remove: rowsSelected
      })
      this.gridApi1.applyTransaction({
        add: rowsSelected
      })

      const rows2 = this.rows2?.filter(row => !rowsSelected.includes(row))
      const rows1 = [...this.rows1, ...rowsSelected]

      this.$emit('transferData', rows1, rows2)
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-title {
  font-weight: 700;
  color: #357456;
  text-transform: uppercase;
  margin: 10px 0;
}

.btn {
  background: #357456;
  border-radius: 5px;
  &.only-icon {
    i {
      color: #fff;
    }
  }
}
</style>
